import { useAuth } from "@savvy/runtime";
import { Button, Card, Input, Label } from "@savvy/ui";
import { useState, type FormEvent } from "react";

export function LoginPage() {
  const login = useAuth((s) => s.login);
  const status = useAuth((s) => s.status);
  const error = useAuth((s) => s.error);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    void login(username, password);
  };

  return (
    <div className="grid min-h-screen place-items-center">
      <Card className="min-w-72 p-8">
        <form onSubmit={submit} className="flex flex-col gap-3">
          <h1 className="mb-1 text-lg font-semibold">Savvy Supervisor</h1>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="username">Username</Label>
            <Input
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <Button type="submit" variant="default" disabled={status === "authenticating"}>
            {status === "authenticating" ? "Signing in…" : "Sign in"}
          </Button>
          {error && (
            <p className="rounded-md bg-danger-bg px-2.5 py-1.5 text-sm text-danger">{error}</p>
          )}
        </form>
      </Card>
    </div>
  );
}
